import { apiFetch } from '../../../lib/api';

/**
 * Fetch current user's active sessions
 * @param {string} [token] - Optional access token
 */
export const getMySessions = async (token) => {
    const endpoint = '/api/v1/auth/users/me/sessions';
    return apiFetch(endpoint, {
        method: 'GET',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
};

/**
 * Revoke a specific session
 * @param {string} sessionId - ID of the session to revoke
 * @param {string} [token] - Optional access token
 */
export const revokeSession = async (sessionId, token) => {
    const endpoint = `/api/v1/auth/users/me/sessions/${sessionId}`;
    return apiFetch(endpoint, {
        method: 'DELETE',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
};

/**
 * Revoke all sessions (except current)
 * @param {string} [token] - Optional access token
 */
export const revokeAllSessions = async (token) => {
    const endpoint = '/api/v1/auth/users/me/sessions/revoke-all';
    return apiFetch(endpoint, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
};

/**
 * Admin: Fetch active sessions for a target user
 * @param {string} targetUserId - Target user UUID
 * @param {string} [token] - Optional access token
 */
export const getAdminUserSessions = async (targetUserId, token) => {
    const endpoint = `/api/v1/auth/admin/users/${targetUserId}/sessions`;
    return apiFetch(endpoint, {
        method: 'GET',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
};

/**
 * Admin: Revoke all active sessions for a target user
 * @param {string} targetUserId - Target user UUID
 * @param {string} [token] - Optional access token
 */
export const revokeAdminUserSessions = async (targetUserId, token) => {
    const endpoint = `/api/v1/auth/admin/users/${targetUserId}/sessions/revoke`;
    return apiFetch(endpoint, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
};

